import { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, getStoredUser, setStoredUser, clearToken } from "@/lib/api";

const AuthContext = createContext(null);

export const ROLE_ADMIN = "admin";
export const ROLE_MANAGER = "manager";
export const ROLE_USER = "user";

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => getStoredUser());
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = getToken();
        if (!token) {
            setLoading(false);
            return;
        }
        api
            .get("/auth/me")
            .then((r) => {
                setUser(r.data);
                setStoredUser(r.data);
            })
            .catch(() => {
                clearToken();
                setUser(null);
            })
            .finally(() => setLoading(false));
    }, []);

    const value = {
        user,
        loading,
        setUser: (u) => {
            setUser(u);
            setStoredUser(u);
        },
        logout: () => {
            clearToken();
            setUser(null);
        },
        isAdmin: user?.role === ROLE_ADMIN || user?.is_supervisor,
        isManager: user?.role === ROLE_MANAGER,
        isUser: user?.role === ROLE_USER,
        canManageUsers:
            user?.role === ROLE_ADMIN || user?.role === ROLE_MANAGER,
        canEdit: user?.role === ROLE_ADMIN || user?.role === ROLE_MANAGER,
        canAccessSecurity:
            user?.role === ROLE_ADMIN || user?.role === ROLE_MANAGER,
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
